import * as dd from 'dingtalk-jsapi'
/* eslint-disable */
export function GetCode(callback) {
    const corpId = 'ding8a04c0a9563026de35c2f4657eb6378f' //钉钉企业id
        // dd.config({
        //     corpId: corpId, //必填，企业ID
        //     type: 0,
        //     jsApiList: ['runtime.info', 'biz.contact.choose', 'biz.contact.chooseMobileContacts',
        //             'device.notification.confirm', 'device.notification.alert',
        //             'device.notification.prompt', 'biz.ding.post', 'biz.util.previewImage',
        //             'biz.util.openLink', 'device.geolocation.start', 'device.geolocation.get', 'biz.util.uploadImageFromCamera', 'biz.util.uploadImage',
        //             'device.audio.startRecord', 'device.audio.stopRecord', 'device.audio.play', 'device.audio.pause', 'device.audio.download', 'device.audio.translateVoice', 'device.audio.onPlayEnd', 'runtime.permission.requestAuthCode'
        //         ] // 必填，需要使用的jsapi列表，注意：不要带dd。
        // });
    if (dd.env.platform !== 'notInDingTalk') {
        alert('666666')
        dd.ready(() => {
            alert('在钉钉环境中')
                // 在钉钉环境中，执行相关操作
                // dd.runtime.permission.requestAuthCode({
                //     corpId: 'ding8a04c0a9563026de35c2f4657eb6378f',
                //     onSuccess: function(info) {
                //         alert(res.code);
                //         console.log(res);
                //     },
                //     onFail: function(err) {
                //         console.log(1111111);
                //         console.log(err);
                //         alert("免登码获取失败：" + err.errorMessage);
                //         alert(JSON.stringify(err))
                //         callback(err);
                //     }
                // })
            dd.getAuthCode({
                corpId: "ding8a04c0a9563026de35c2f4657eb6378f",
                onSuccess: async(res) => {
                    // alert(res.code);
                    callback(res.code);
                },
                onFail: function(err) {
                    console.log(err);
                    alert("免登码获取失败：" + err.errorMessage);
                },
            });
        })
    } else {
        // 如果不在钉钉内部，可以执行其他操作或提示用户
        // 例如，可以调用callback并传递一个错误对象或消息
        callback({ message: '不在钉钉环境中' });
    }
    // dd.device.notification.alert({
    //     message: '不在钉钉环境中',
    //     title: '提示',
    //     buttonName: '确定',
    //     onSuccess: function() {
    //         // 点击确认按钮回调
    //         alert('1111111');
    //     },
    //     onFail: function(err) {
    //         // 点击取消按钮回调
    //     }
    // });

    // if (typeof dd !== 'object' || !dd) {
    //     alert('dd对象不存在，请确保JSAPI已经初始化');
    //     return;
    // }
    // dd.ready(() => {
    //     alert('在钉钉环境中')

    //     // 在钉钉环境中，执行相关操作
    //     dd.runtime.permission.requestAuthCode({
    //         corpId: 'ding8a04c0a9563026de35c2f4657eb6378f',
    //         // onSuccess: (info) => {
    //         //     console.log(2222222);
    //         //     callback(null, info.code)
    //         // },
    //         // onFail: (err) => {
    //         //     console.log(1111111);
    //         //     console.log(err);
    //         //     alert(JSON.stringify(err))
    //         //     callback(err);
    //         // }
    //     }).then((info) => {
    //         console.log(2222222);
    //     }).catch((err) => {
    //         console.log(111111111111);
    //         console.log(err);
    //     })
    // })

    // function requestAuthCode() {
    //     return new Promise((resolve, reject) => {
    //         dd.ready(function() {
    //             dd.runtime.permission.requestAuthCode({
    //                 corpId: 'your_corp_id',
    //                 onSuccess: function(result) {
    //                     resolve(result);
    //                 },
    //                 onFail: function(error) {
    //                     reject(error);
    //                 }
    //             });
    //         });
    //     });
    // }

    // // 使用异步函数调用 requestAuthCode，并处理异常
    // async function handleRequest() {
    //     try {
    //         const result = await requestAuthCode();
    //         console.log('requestAuthCode success:', result);
    //         // 处理授权成功后的逻辑
    //     } catch (error) {
    //         console.log('requestAuthCode fail:', error);
    //         // 处理授权失败后的逻辑
    //     }
    // }

    // handleRequest();


}